import { Capacitor, registerPlugin } from '@capacitor/core'

import type { DualScreenPlugin } from './definitions.js'

const DualScreen = registerPlugin<DualScreenPlugin>('DualScreen', {
  web: async () => {
    if (Capacitor.getPlatform() === 'electron') {
      const { DualScreenElectron } = await import('./electron.js')
      return new DualScreenElectron()
    }
    const { DualScreenWeb } = await import('./web.js')
    return new DualScreenWeb()
  }
})

export * from './definitions.js'
export { DualScreen }
